// What a post is for. The first five sell the product to people who have never heard of it; the later ones suit
// readers who already know it.
export const GOALS = [
  { key: 'introduce', label: 'Introduce the product' },
  { key: 'show_result', label: 'Show the result' },
  { key: 'solve_pain', label: 'Solve a pain' },
  { key: 'how_it_works', label: 'How it works' },
  { key: 'offer', label: 'Make the offer' }
];

export const LATER_GOALS = [
  { key: 'feature', label: 'Feature spotlight' },
  { key: 'use_case', label: 'Use case' },
  { key: 'launch', label: 'Launch news' },
  { key: 'build_in_public', label: 'Build in public' },
  { key: 'lesson', label: 'Lesson learned' }
];

// Earlier angle names, still found on older posts and saved settings.
export const LEGACY_GOALS = { problem_fix: 'solve_pain', showcase: 'show_result' };

export const GOAL_LABELS = GOALS.concat(LATER_GOALS).reduce((labels, goal) => {
  labels[goal.key] = goal.label;
  return labels;
}, { problem_fix: 'Solve a pain', showcase: 'Show the result' });

// What the image-reading look judged a picture to be.
export const ROLE_LABELS = {
  product_ui: 'Product screen', example: 'Example', before: 'Before', after: 'After', logo: 'Logo', person: 'People',
  decorative: 'Decoration', text_graphic: 'Mostly text', other: 'Other'
};
